import { Component } from "@angular/core";
import { clientConfig } from "../../shared/constant/app.constant";

@Component({
  selector: "app-mobile-home",
  templateUrl: "./home.component.html",
  styles: [],
})
export class MobileHomeComponent {
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL,
    description: "This is our branding",
  };
}
